import { render, staticRenderFns } from "./TextEditorDialog.vue?vue&type=template&id=5a0992d6&scoped=true&"
import script from "./TextEditorDialog.vue?vue&type=script&lang=js&"
export * from "./TextEditorDialog.vue?vue&type=script&lang=js&"
import style0 from "./TextEditorDialog.vue?vue&type=style&index=0&id=5a0992d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0992d6",
  null
  
)

export default component.exports